import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
request.get('/api/v4ward/warehouse/distribute/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
request.get('/api/v4ward/custom/form/main/detail', Object.assign({}, options, { params }))

// 获取总金额
export const getSummary = (params, options) =>
request.get('/api/v4ward/warehouse/outbound/record/summary', Object.assign({}, options, { params }))

// 保存
export const distributeSave = (params, options) =>
request.post('/api/v4ward/warehouse/distribute/save', params,options);

// 提交
export const distributeSubmit = (params, options) =>
request.post('/api/v4ward/warehouse/distribute/submit', params,options);
// 通过当前登录人获取科室
export const treeDeptsByIds = (params, options) =>
request.get('/api/v4ward/dept/listByUser', Object.assign({}, options, { params }));

// 使用人 /v4ward/user/getUserNowList
// 通过当前登录人获取科室
export const getUserNowList = (params, options) =>
request.get('/api/v4ward/user/user-list-by-dept', Object.assign({}, options, { params }));

// 获取单号
export const getBusinessNo = (params, options) =>
request.get('/api/v4ward/warehouse/common/getBusinessNo', Object.assign({}, options, { params }));

// 查看 编辑中获取 物品列表
export const getConsumableListByDistributeId = (params, options) =>
request.get('/api/v4ward/warehouse/distribute/consumable/getConsumableListByDistributeId', Object.assign({}, options, { params }));

//列表
export const consumableList = (params, options) =>
    request.get('/api/v4ward/warehouse/dept/stock/list', Object.assign({}, options, { params }));


